export default __webpack_public_path__ + "static/navImg4-c6a0b9835a21f1eec7778da174af22e9.jpg";